export default __webpack_public_path__ + "static/media/vid3.0bb44243.mp4";